import React from 'react';
import styled from 'styled-components';

import theme from '../../../../styled-components/dark';
import { MissionRightArrow } from '../../assets/svg';

const Wrapper = styled.div`
  width: 2em;
  height: 2em;

  background-color: ${theme.MissionBanner.expandBackgroundColor};
  border-radius: 9999px;
  flex-shrink: 0;

  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledArrowDown = styled(MissionRightArrow)`
  width: 0.5em;
  transform: rotate(90deg);
  color: white;
`;

type MissionExpandButtonPropsType = {
  className?: string;
  onClick: (e: React.MouseEvent<HTMLElement>) => void;
};

const MissionExpandButton = ({ className = '', onClick }: MissionExpandButtonPropsType) => {
  return (
    <Wrapper className={className} onClick={onClick}>
      <StyledArrowDown />
    </Wrapper>
  );
};

export default MissionExpandButton;
